export default __webpack_public_path__ + "static/media/Audio_Icon.89cbc9c7.svg";